// Module
var code = `<template>
  <require from="./text-widget.scss"></require>

  <!-- beautify ignore:start -->
  <style>
    .text-widget-\${id} {
      font-family: \${font || 'var(--dyn-default-font-family)'};
      font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
      font-weight: \${fontWeight};
      color: \${color | widgetTemplateColor:isInDashboard} !important;
      text-align: \${textAlign || 'left'};
    }
  </style>
  <!-- beautify ignore:end -->

  <div class="text-widget text-widget-\${id}">
    <div class="text-widget__text">\${text}</div>
    <div class="text-widget__menu-anchor" ref="menuAnchor"></div>
  </div>
</template>
`;
// Exports
export default code;